'use strict';

class MeViewCtrl {
  constructor(UserSvc) {
    var that = this;
    UserSvc.getMe().$promise
      .then(function(user) {
        that.user = user.person;
      });
  }
}

MeViewCtrl.$inject = ['UserSvc'];

export default ['UserSvc', MeViewCtrl];
